import { Typography } from "@mui/material";
import { icons } from "assets/AssetHelper";
import * as dayjs from "dayjs";

export const detailsData = ({ data, t }) => [
  {
    head: t("common.details"),
    icon: icons?.detailsIcon,
    details: [
      {
        label: t("wrappers_wrap_variants.name_en"),
        name: data?.localized_data?.en?.name,
      },
      {
        label: t("wrappers_wrap_variants.name_ar"),
        name: data?.localized_data?.ar?.name,
      },
      {
        label: t("wrappers_wrap_variants.shape"),
        name: (
          <div
            style={{
              borderRadius: "4px",
              backgroundColor: "#F5F5F5",
              textAlign: "center",
              padding: "3px 15px",
            }}
          >
            <Typography color="#6A6A6A" fontSize="18px" fontFamily="Cairo">
              {data?.shape?.name}
            </Typography>
          </div>
        ),
        width: "15%",
      },
      {
        label: t("wrappers_wrap_variants.color"),
        name: (
          <div
            style={{
              borderRadius: "4px",
              backgroundColor: "#F5F5F5",
              textAlign: "center",
              padding: "3px 15px",
            }}
          >
            <Typography color="#6A6A6A" fontSize="18px" fontFamily="Cairo">
              {data?.color?.name}
            </Typography>
          </div>
        ),
        width: "15%",
      },
      {
        label: t("wrappers_wrap_variants.wrap"),
        name: (
          <div
            style={{
              borderRadius: "4px",
              backgroundColor: "#F5F5F5",
              textAlign: "center",
              padding: "3px 15px",
            }}
          >
            <Typography color="#6A6A6A" fontSize="18px" fontFamily="Cairo">
              {data?.wrap?.name}
            </Typography>
          </div>
        ),
        width: "15%",
      },
      {
        label: t("wrappers_wrap_variants.show_in_packaging"),
        name:
          data?.show_in_packaging === true
            ? t("common.yes")
            : data?.show_in_packaging === false
              ? t("common.no")
              : "-",
      },
      {
        label: t("wrappers_wrap_variants.is_active"),
        name:
          data?.is_active === true
            ? t("common.yes")
            : data?.is_active === false
              ? t("common.no")
              : "-",
      },
      {
        label: t("wrappers_wrap_variants.display_priority"),
        name: data?.display_priority ?? 0,
      },
    ],
  },
  {
    head: t("common.prices"),
    icon: icons?.priceIcon,
    details: [
      {
        label: t("wrappers_wrap_variants.price"),
        name: `${data?.price} ${data?.currency?.name}`,
      },
      {
        label: t("wrappers_wrap_variants.price_after_discount"),
        name: `${data?.price_after_discount} ${data?.currency?.name}`,
      },
    ],
  },
  {
    head: t("details.dates"),
    icon: icons.datesIcons,
    details: [
      {
        label: t("details.created_at"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("details.updated_at"),
        name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
      },
    ],
  },
];
